export function sourceLabel(value: string | null | undefined): string {
  if (value === "ai_intake") return "AI intake";
  if (value === "contact") return "Contact";
  return value || "—";
}
